import { render, staticRenderFns } from "./TeacherCombo.vue?vue&type=template&id=17ab5b06"
import script from "./TeacherCombo.vue?vue&type=script&lang=js"
export * from "./TeacherCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ab5b06')) {
      api.createRecord('17ab5b06', component.options)
    } else {
      api.reload('17ab5b06', component.options)
    }
    module.hot.accept("./TeacherCombo.vue?vue&type=template&id=17ab5b06", function () {
      api.rerender('17ab5b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/TeacherCombo.vue"
export default component.exports